import { render } from "./InterView.vue?vue&type=template&id=a4f2dbca"
import script from "./InterView.vue?vue&type=script&lang=js"
export * from "./InterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__